import { useState, useEffect } from 'react';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('home')}>
          <img 
            src="https://public.readdy.ai/ai/img_res/9fbf73c7-9765-4cbe-b478-b523a6e9321a.png" 
            alt="Live Your Best Life Therapy & Coaching Logo" 
            className="h-12 w-auto"
          />
          <span className={`text-xl font-semibold transition-colors ${isScrolled ? 'text-gray-900' : 'text-white'}`} style={{ fontFamily: 'Playfair Display, serif' }}>
            Live Your Best Life
          </span>
        </div>
        
        <div className="flex items-center gap-8">
          {['Home', 'About', 'Services', 'Testimonials', 'Gallery', 'Contact'].map((item) => (
            <button
              key={item}
              onClick={() => scrollToSection(item.toLowerCase())}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-[#2C5F7C]' : 'text-white hover:text-[#A8DADC]'
              }`}
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              {item}
            </button>
          ))}
        </div>
      </div>
    </nav>
  );
}
